import * as Sentry from '@sentry/vue';
import { Breadcrumb, BreadcrumbHint } from '@sentry/vue';

/**
 * Used to capture Errors, other than the default uncaught exceptions which are already captured by Sentry.
 *
 * @param exception
 */
export const captureSentryException = (exception: unknown) => {
  Sentry.captureException(exception);
};

/**
 * ⚠️ THIS CAN BE EXPENSIVE. USE SPARINGLY.
 *
 * Capture random stuff
 * @param message
 * @param extra
 */
export const captureSentryMessage = (message: string, extra?: Record<string, unknown>) => {
  Sentry.captureMessage(message, {
    extra: extra,
  });
};

/**
 * Set context
 * @param name
 * @param context
 */
export const setSentryContext = (name: string, context: Record<string, unknown>) => {
  Sentry.setContext(name, context);
};

/**
 * Add breadcrumb
 * @param breadcrumb
 * @param hint
 */
export const addSentryBreadcrumb = (breadcrumb: Breadcrumb, hint?: BreadcrumbHint) => {
  Sentry.addBreadcrumb(breadcrumb, hint);
};
